import {CategoriesEditor} from "./CategoriesEditor.js";
import {CategoriesDirectEditor} from "./CategoriesDirectEditor.js";

/**
 * Convert array of values to right type depending on second array with types (number|string)
 * @param {[string|number]} values
 * @param {[string]} types
 */
function castValues(values, types) {
	if (!Array.isArray(types) || !Array.isArray(values)) return values;
	const converted = [];
	for (let i = 0; i < values.length; i++) {
		let val = values[i];
		if (i < types.length) {
			const type = types[i];
			if (typeof val !== type) {
				if (typeof val === 'string' && type === 'number') {
					val = parseInt(val);
				} else {
					val = val.toString();
				}
			}
		}
		converted.push(val);
	}
	return converted;
}

/**
 * Generate comma separated list of values with types of values "string,string,number,string,..."
 * @param {[string|number]} values
 * @return {string}
 */
function toTypeArray(values) {
	const types = [];
	for (let val of values) {
		types.push(typeof val);
	}
	return types.join(",");
}

export class CategoriesInput {
	constructor(input, options, container) {
		let i;
		let idToRegister;
		if (typeof input === 'string') {
			i = $('#' + input);
			idToRegister = input;
		} else {
			i = input;
			idToRegister = i.attr("id");
			if (!idToRegister) idToRegister = i.attr("name");
		}

		const proxy = {
			input : i,
			get data() {
				const str = this.input.val();
				if (str.trim().length === 0) return [];
				let valueArray = str.split(",");
				const valueTypes = this.input.attr("data-type");
				if (valueTypes) {
					valueArray = castValues(valueArray, valueTypes.split(","));
				}
				return valueArray;
			},
			set data(arr) {
				let v, t;
				if (arr == null || arr.length === 0) v = t = "";
				else {
					v = arr.join(",");
					t = toTypeArray(arr);
				}
				this.input.val(v);
				this.input.attr("data-type", t);
			}
		}

		if (typeof container === "undefined" || container == null) container = i.parent();
		
		if (options.direct) {
			this.ed = new CategoriesDirectEditor(i.attr("name"), proxy, "data", options);
		}
		else {
			this.ed = new CategoriesEditor(null, i.attr("name"), proxy, "data", options);
		}
		container.append(this.ed.ui);

		window["ci_"+idToRegister] = this;
	}

	/**
	 * Enable/Disable this input (enable(false) makes it read-only)
	 * @param {boolean} state
	 */
	enable(state) {
		if (state) this.ed.enable();
		else this.ed.disable();
	}

	static find(id) {
		return window["ci_" + id];
	}
}

export function switchEnable(categoriesId,checkboxId)
{
	CategoriesInput.find(categoriesId).enable(!$('#'+checkboxId).is(':checked'));
}